import { HStack, Text, Icon, Box, CSSObject, BoxProps, Flex } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import Content from '~/containers/Content';

import {
  IoFileTrayOutline,
  IoReceiptOutline,
  IoPersonOutline,
  IoLogIn,
  IoLogOut,
} from 'react-icons/io5';
import { useMemo } from 'react';
import getPath from '~/utils/getNavigatePath';

const EnterpriseGroupBuyNavList = [
  {
    title: '訂單',
    icon: IoReceiptOutline,
    link: 'orderList',
  },
];

const navList = [
  {
    title: '訂單',
    icon: IoReceiptOutline,
    link: 'orderList',
  },
  {
    title: '專屬優惠',
    icon: IoPersonOutline,
    link: 'coupons',
  },
  {
    title: '餐盒回收',
    icon: IoFileTrayOutline,
    link: 'mealBoxRecycling',
  },
];

type NavBarProps = {
  isOpen: boolean;
  isLogin: boolean;
  onClose: () => void;
  onLoginLogout: () => void;
} & BoxProps;

export default function NavBar({ isOpen, isLogin, onClose, onLoginLogout, ...props }: NavBarProps) {
  const { pathname } = useLocation();
  const { groupId = '', enterpriseGroupBuyId = '' } = useParams();

  const handleUnderLine = (active: boolean): CSSObject => {
    return {
      content: '""',
      position: 'absolute',
      bottom: '-3px',
      w: 'full',
      h: '3px',
      bgColor: active ? 'primary' : 'transparent',
    };
  };
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(getPath(`/${path}`, groupId, enterpriseGroupBuyId));
  };

  const displayNavList = useMemo(() => {
    if (!!enterpriseGroupBuyId && pathname.startsWith('/enterpriseGroupBuy'))
      return EnterpriseGroupBuyNavList;
    return navList;
  }, [enterpriseGroupBuyId, pathname]);

  return (
    <Box as="nav" bgColor="white" {...props}>
      <Content m="auto">
        <Flex
          sx={{ '& > *': { maxW: !!enterpriseGroupBuyId ? '180px' : 'auto' } }}
          alignItems="center"
          justifyContent="center"
        >
          {displayNavList.map(({ title, icon, link }) => {
            const isMatchPath = pathname.includes(link);
            return (
              <HStack
                as="a"
                key={link}
                onClick={() => handleNavigate(link)}
                flex="1"
                position="relative"
                justify="center"
                bgColor="white"
                py={3}
                cursor="pointer"
                _before={handleUnderLine(isMatchPath)}
                _hover={{
                  color: 'primary',
                }}
              >
                <Icon boxSize="1.125rem" as={icon} color={isMatchPath ? 'primary' : 'inherit'} />
                <Text
                  fontSize="sm"
                  letterSpacing={2}
                  color={isMatchPath ? 'primary' : 'inherit'}
                  fontWeight={isMatchPath ? 'bold' : 'normal'}
                >
                  {title}
                </Text>
              </HStack>
            );
          })}
          <HStack
            flex="1"
            align="center"
            cursor="pointer"
            justify="center"
            position="relative"
            py={3}
            onClick={onLoginLogout}
            _before={handleUnderLine(false)}
            _hover={{
              color: 'primary',
            }}
          >
            <Icon as={isLogin ? IoLogOut : IoLogIn} boxSize="1.125rem" color="inherit" />
            <Text fontSize="sm" letterSpacing={2} color="inherit">
              {isLogin ? '登出' : '登入'}
            </Text>
          </HStack>
        </Flex>
      </Content>
    </Box>
  );
}
